import { InjectionToken } from '@angular/core';
import type { FirebaseStorage } from 'firebase/storage';

export {
  connectStorageEmulator,
  deleteObject,
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
} from 'firebase/storage';

/** Cloud Storage for the default app; injectable and usable as a type. */
export const Storage = new InjectionToken<FirebaseStorage>('FirebaseStorage');
export type Storage = FirebaseStorage;
